import { Github, Heart, Shield } from 'lucide-react';
import { RGPDButton } from './RGPDButton';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="shadow-lg border-t-2 mt-auto transition-colors duration-300"
      style={{ backgroundColor: 'var(--wcag-bg)', borderColor: 'var(--wcag-border)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2" style={{ color: 'var(--wcag-text)' }}>
            <Shield className="w-5 h-5" />
            <span className="text-sm font-medium">
              © {currentYear} Arnaqu'Quiz - Protégez-vous des arnaques
            </span>
          </div>

          <div className="flex items-center gap-4">
            <RGPDButton />
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:opacity-80"
              style={{ color: 'var(--wcag-text)' }}
              aria-label="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
            <div
              className="flex items-center gap-1 text-sm font-medium"
              style={{ color: 'var(--wcag-text)' }}
            >
              <span>Fait avec</span>
              <Heart className="w-4 h-4 fill-current" style={{ color: 'var(--wcag-danger)' }} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
